import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ChevronDown } from "lucide-react";
import { SITE, NAV } from "../data/mock";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const NavGroup = ({ label, items }) => (
    <div className="relative group">
      <button className="flex items-center gap-1 px-4 py-6 text-[15px] font-medium text-slate-700 hover:text-[#29abe2] transition-colors">
        {label}
        <ChevronDown className="w-3.5 h-3.5 opacity-60 group-hover:rotate-180 transition-transform duration-300" />
      </button>
      <div className="absolute left-1/2 -translate-x-1/2 top-full pt-1 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
        <div className="bg-white shadow-xl border border-slate-100 rounded-md py-2 min-w-[220px]">
          {items.map((item) => (
            <Link
              key={item.label}
              to={item.href}
              className="block px-5 py-2.5 text-[14px] text-slate-700 hover:text-[#29abe2] hover:bg-slate-50 transition-colors"
            >
              {item.label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <header
      className={`sticky top-0 z-50 w-full bg-white transition-shadow ${
        scrolled ? "shadow-md" : "shadow-sm"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between">
        <Link to="/" className="flex items-center py-3">
          <img src={SITE.logo} alt="TapTrack" className="h-12 w-auto" />
        </Link>

        <nav className="hidden lg:flex items-center gap-2">
          <NavGroup label="Services" items={NAV.services} />
          <NavGroup label="Resources" items={NAV.resources} />
          <NavGroup label="Company" items={NAV.company} />
          <Link
            to="/shop"
            className="px-4 py-6 text-[15px] font-medium text-slate-700 hover:text-[#29abe2] transition-colors"
          >
            Shop
          </Link>
          <Link
            to="/contact-us"
            className="ml-4 bg-[#29abe2] hover:bg-[#1f9bd0] text-white text-[13px] font-semibold tracking-wider px-7 py-3 rounded transition-colors"
          >
            CONTACT
          </Link>
        </nav>

        <button
          aria-label="Toggle menu"
          onClick={() => setOpen(!open)}
          className="lg:hidden p-2 text-slate-700"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-100 bg-white">
          <div className="px-6 py-4 space-y-4">
            <MobileGroup title="Services" items={NAV.services} />
            <MobileGroup title="Resources" items={NAV.resources} />
            <MobileGroup title="Company" items={NAV.company} />
            <Link to="/shop" className="block py-2 text-slate-700 font-medium">Shop</Link>
            <Link
              to="/contact-us"
              className="block text-center bg-[#29abe2] hover:bg-[#1f9bd0] text-white font-semibold tracking-wider px-6 py-3 rounded transition-colors"
            >
              CONTACT
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}

function MobileGroup({ title, items }) {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between py-2 text-slate-800 font-medium"
      >
        {title}
        <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="pl-4 pb-2 space-y-2">
          {items.map((it) => (
            <Link
              key={it.label}
              to={it.href}
              className="block py-1.5 text-slate-600 text-[14px] hover:text-[#29abe2]"
            >
              {it.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
